import React from "react";

import styles from "./Avatar.module.scss";

const Avatar = ({ color = `hsl(0, 40%, 60%)`, imageUrl, initials }) => {
  if (imageUrl) {
    return <img className={styles.img} src={imageUrl} alt="Avatar" />;
  }

  return (
    <div className={styles.initials} style={{ backgroundColor: color }}>
      {initials}
    </div>
  );
};

export default Avatar;
